import { ActionTypes } from './actionTypes';
import type * as Actions from './actions';

import type { UUID } from '@cobliteam/common-types';

import type { MaintenanceRemindersSetup, Recurrence, UpcomingMaintenancesByStatus } from '@cobliteam/api-lib';

export const loadUpcomingMaintenancesRequest = (): Actions.LoadUpcomingMaintenancesRequest => ({
  type: ActionTypes.LOAD_UPCOMING_MAINTENANCES_REQUEST,
});

export const loadUpcomingMaintenancesSucceeded = (upcoming: UpcomingMaintenancesByStatus): Actions.LoadUpcomingMaintenancesSucceeded => ({
  type: ActionTypes.LOAD_UPCOMING_MAINTENANCES_SUCCEEDED,
  payload: upcoming,
});

export const loadUpcomingtMaintenancesFailed = (): Actions.LoadUpcomingMaintenancesFailed => ({
  type: ActionTypes.LOAD_UPCOMING_MAINTENANCES_FAILED,
});

export const editRemindersRequest = (vehicleId: UUID, recurrences: Recurrence[]): Actions.EditRemindersRequest => ({
  type: ActionTypes.EDIT_REMINDERS_REQUEST,
  payload: { vehicleId, recurrences },
});

export const deleteRemindersRequest = (vehicleIds: UUID[]): Actions.DeleteRemindersRequest => ({
  type: ActionTypes.DELETE_REMINDERS_REQUEST,
  payload: vehicleIds,
});

export const setupRemindersRequest = (data: MaintenanceRemindersSetup): Actions.SetupRemindersRequest => ({
  type: ActionTypes.SETUP_REMINDERS_REQUEST,
  payload: data,
});
